import {ReactElement} from "react";
import ProjectSettingsLayout from "@/components/layouts/ProjectSettingsLayout";
import GeneralDetailsCard from "@/components/settings/project-settings/GeneralDetailsCard";
import ProjectIDCard from "@/components/teams/general-details/IDCard";
import {useRouter} from "next/router";
import ApiKeyModal from "@/components/settings/model-settings/ApiKeyModal";

function General() {
  const router = useRouter();
  const {projectId} = router.query;
  return (
    <div className="mt-12 pb-20">
      {/*<GeneralDetailsCard id={projectId as string}/>*/}
      <ProjectIDCard id={projectId}/>
      <ApiKeyModal/>
    </div>
  )
}

General.getLayout = function getLayout(page: ReactElement) {
  return <ProjectSettingsLayout>{page}</ProjectSettingsLayout>;
};

export default General
